// extracted by mini-css-extract-plugin
export default {"cls1":"ToolsMenu-cls1_ctj","cls2":"ToolsMenu-cls2_n72 ToolsMenu-cls1_ctj"};